export default __webpack_public_path__ + "static/media/1206.4c2c8c63.png";